/* Shopify-only commerce bridge. Inactive in the local design preview. */
(() => {
  'use strict';
  const config = window.MDMTheme;
  if (!config?.shopify) return;
  const $ = (selector, root = document) => root?.querySelector(selector) || null;
  const $$ = (selector, root = document) => [...(root?.querySelectorAll(selector) || [])];
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const root = config.root || window.Shopify?.routes?.root || '/';
  const dialog = $('.cart-dialog');
  let state = null;
  let focusBefore = null;
  let working = false;
  let queue = Promise.resolve();
  let badgeSequence = 0;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {style:'currency',currency:state?.currency || config.currency || 'EUR'}).format(cents / 100);
  const icon = name => `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${{
    bag:'<path d="M5 7h14l1 14H4L5 7Z"/><path d="M8 7V5a4 4 0 0 1 8 0v2"/>',
    truck:'<path d="M3 5h11v11H3zM14 9h4l3 4v3h-7"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/>',
    check:'<path d="m6 12 4 4 8-8"/>',
    lock:'<rect x="5" y="10" width="14" height="11" rx="2"/><path d="M8 10V6a4 4 0 0 1 8 0v4M12 14v3"/>',
    chat:'<path d="M20 11a8 8 0 0 1-8 8H5l-3 3V11a9 9 0 0 1 18 0Z"/><path d="M7 9h8M7 13h5"/>'
  }[name] || ''}</svg>`;

  function notice(message, error = false) {
    const panel = $('.cart-notice', dialog);
    if (panel) { panel.textContent = message; panel.hidden = !message; panel.setAttribute('role', error ? 'alert' : 'status'); }
    const live = $('#mdm-commerce-status');
    if (live) live.textContent = message;
    if (error && !dialog?.open) {
      const toast = $('.toast');
      if (toast) { toast.textContent = message; toast.hidden = false; setTimeout(() => { toast.hidden = true; }, 6500); }
    }
  }

  async function request(path, payload) {
    const response = await fetch(root + path, {
      method: payload ? 'POST' : 'GET', credentials: 'same-origin',
      headers: { Accept: 'application/json', ...(payload ? {'Content-Type':'application/json'} : {}) },
      ...(payload ? {body:JSON.stringify(payload)} : {})
    });
    let data;
    try { data = await response.json(); } catch { throw new Error('Le panier est momentanément indisponible. Réessayez dans un instant.'); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : 'Cette quantité ne peut pas être ajoutée. Vérifiez votre sélection.');
    return data;
  }

  function badges() {
    const source = $('#mdm-payment-template');
    if (!source) return '';
    const wrapper = document.createElement('div');
    wrapper.className = 'mdm-payments cart-payment-badges';
    wrapper.append(source.content.cloneNode(true));
    const ids = new Map();
    $$('[id]', wrapper).forEach((element, index) => { const old = element.id; element.id = `mdm-payment-${++badgeSequence}-${index}`; ids.set(old, element.id); });
    $$('*', wrapper).forEach(element => [...element.attributes].forEach(attribute => {
      let value = attribute.value;
      ids.forEach((replacement, old) => { value = value.split(`url(#${old})`).join(`url(#${replacement})`); if (value === `#${old}`) value = `#${replacement}`; if (attribute.name.startsWith('aria-')) value = value.split(' ').map(token => token === old ? replacement : token).join(' '); });
      if (value !== attribute.value) element.setAttribute(attribute.name, value);
    }));
    return wrapper.outerHTML;
  }

  function render() {
    if (!state) return;
    $$('.cart-count, .cart-title-count').forEach(element => { element.textContent = String(state.item_count); });
    $$('.cart-open').forEach(element => element.setAttribute('aria-label', `Ouvrir le panier, ${state.item_count} article${state.item_count === 1 ? '' : 's'}`));
    const content = $('#cart-content');
    if (!content) return;
    const threshold = Number(config.shippingThreshold) || 5000;
    const qualifies = state.currency === 'EUR';
    const earned = qualifies && state.total_price >= threshold;
    const shippingMessage = earned ? 'Votre livraison est offerte.' : `Encore ${money(Math.max(0, threshold - state.total_price))} pour la livraison offerte.`;
    const progress = Math.min(100, state.total_price / threshold * 100);
    const shipping = qualifies ? `<div class="cart-shipping ${earned ? 'is-earned' : ''}"><div class="cart-shipping-heading"><span class="cart-shipping-icon">${icon(earned ? 'check' : 'truck')}</span><p class="cart-shipping-message" role="status">${shippingMessage}</p></div><div class="shipping-track" role="progressbar" aria-label="Progression vers la livraison offerte" aria-valuemin="0" aria-valuemax="${threshold}" aria-valuenow="${Math.min(state.total_price, threshold)}" aria-valuetext="${escape(shippingMessage)}"><span style="width:${progress}%"></span></div><div class="cart-shipping-scale"><span>${money(0)}</span><span>${money(threshold)} · Livraison offerte</span></div><a class="cart-shipping-conditions" href="${escape(config.shippingUrl)}">Avec Colissimo, Chronopost & Mondial Relay · Voir les conditions</a></div>` : '';
    if (!state.items.length) {
      content.innerHTML = `${shipping}<div class="cart-empty-state"><span class="cart-empty-icon">${icon('bag')}</span><h3>Une jolie découverte<br>vous attend.</h3><p>Votre panier est encore vide.<br>Trouvez la senteur qui vous ressemble.</p><a class="cta cart-empty-link" href="${escape(config.catalogUrl)}">Découvrir les senteurs</a></div><div class="cart-empty-help">${icon('chat')}<p>Un doute sur le parfum à choisir ?<br><a href="${escape(config.contactUrl)}">Nous sommes là pour vous aider</a></p></div>`;
      return;
    }
    const lines = state.items.map(item => {
      const title = String(item.variant_id) === String(config.coffretVariant || '49387618533719') ? 'Coffret de 4 muscs au choix' : (window.MDM_PRODUCT_CATALOG?.[String(item.variant_id)]?.name || item.product_title);
      const image = item.featured_image?.url || item.image || '';
      const properties = Object.entries(item.properties || {}).filter(([key,value]) => key[0] !== '_' && value !== '').map(([key,value]) => `${escape(key === 'Products' ? 'Vos 4 muscs' : key)} : ${escape(value)}`).join(' · ');
      const detail = [item.variant_title && item.variant_title !== 'Default Title' ? escape(item.variant_title) : '', properties, escape(item.selling_plan_allocation?.selling_plan?.name || '')].filter(Boolean).join(' · ');
      const reductions = (item.line_level_discount_allocations || []).map(discount => `<small class="cart-discount">${escape(discount.discount_application.title)} · −${money(discount.amount)}</small>`).join('');
      return `<article class="cart-line" data-shopify-line="${escape(item.key)}">${image ? `<img src="${escape(image)}" alt="${escape(title)}" width="96" height="96" loading="lazy">` : '<div class="image-unavailable">Mirage de Musc</div>'}<div class="cart-line-info"><div class="cart-line-heading"><h3><a href="${escape(item.url)}">${escape(title)}</a></h3><strong class="cart-line-price">${money(item.final_line_price)}</strong></div><p>${detail}</p><small>${money(item.final_price)} l’unité</small>${reductions}<div class="cart-line-actions"><div class="cart-quantity"><button type="button" data-shopify-step="-1" aria-label="Diminuer la quantité de ${escape(title)}" ${item.quantity <= 1 ? 'disabled' : ''}>−</button><input type="number" min="1" value="${item.quantity}" inputmode="numeric" data-shopify-quantity aria-label="Quantité de ${escape(title)}"><button type="button" data-shopify-step="1" aria-label="Augmenter la quantité de ${escape(title)}">+</button></div><button type="button" class="cart-remove" data-shopify-remove aria-label="Retirer ${escape(title)} du panier">Retirer</button></div></div></article>`;
    }).join('');
    const discounts = (state.cart_level_discount_applications || []).map(discount => `<div class="cart-delivery-row"><span>${escape(discount.title)}</span><span>−${money(discount.total_allocated_amount)}</span></div>`).join('');
    content.innerHTML = `${shipping}<div class="cart-lines">${lines}</div><div class="cart-summary">${discounts}<div class="cart-total"><span>Sous-total</span><strong>${money(state.total_price)}</strong></div><div class="cart-delivery-row"><span>Livraison</span><span class="cart-shipping-cost">${earned ? 'Offerte selon conditions' : 'Calculée au paiement'}</span></div><a class="cta cart-checkout" href="${escape(root + 'checkout')}">${icon('lock')}<span>Continuer vers le paiement</span><span aria-hidden="true">→</span></a><div class="cart-payment-caption">Paiement sécurisé · Vos moyens de paiement habituels</div>${badges()}<div class="cart-reassurance"><a href="${escape(config.shippingUrl)}">${icon('truck')}<span>Suivi de livraison</span></a><a href="${escape(config.contactUrl)}">${icon('chat')}<span>Une question ? Écrivez-nous</span></a></div></div>`;
  }

  function busy(active) {
    working = active;
    dialog?.setAttribute('aria-busy', String(active));
    $$('.generic-add, #add-product, [data-add-duo], [data-shopify-step], [data-shopify-remove], [data-shopify-quantity]').forEach(element => {
      if (active) { element.dataset.mdmWasDisabled = String(element.disabled); element.disabled = true; }
      else if ('mdmWasDisabled' in element.dataset) { element.disabled = element.dataset.mdmWasDisabled === 'true'; delete element.dataset.mdmWasDisabled; }
    });
  }

  function open() {
    if (!dialog) { window.location.assign(root + 'cart'); return; }
    if (!dialog.open) {
      focusBefore = document.activeElement;
      dialog.showModal(); document.body.classList.add('modal-open'); $('.cart-close', dialog)?.focus();
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) dialog.animate?.([{opacity:.7,transform:'translateX(42px)'},{opacity:1,transform:'translateX(0)'}],{duration:330,easing:'cubic-bezier(.2,.75,.25,1)'});
    }
  }
  function close() { if (dialog?.open) dialog.close(); }
  dialog?.addEventListener('close', () => { if (!document.querySelector('dialog[open]')) document.body.classList.remove('modal-open'); if (focusBefore?.isConnected) focusBefore.focus({preventScroll:true}); });

  async function refresh() { state = await request('cart.js'); render(); return state; }
  function enqueue(task) {
    const result = queue.then(async () => {
      busy(true); notice('');
      try { return await task(); }
      catch (error) { try { await refresh(); } catch {} notice(error.message || 'Le panier n’a pas pu être mis à jour. Réessayez.', true); return false; }
      finally { busy(false); }
    });
    queue = result.catch(() => false);
    return result;
  }

  function addMany(requested) {
    if (!Array.isArray(requested) || !requested.length || requested.length > 50) return Promise.resolve(false);
    const combined = new Map();
    for (const entry of requested) {
      const raw = String(entry?.id ?? '');
      const id = String(config.aliases?.[raw] || raw);
      const quantity = Number(entry?.quantity ?? 1);
      if (!/^\d+$/.test(id) || !Number.isSafeInteger(quantity) || quantity < 1) return Promise.resolve(false);
      if (id === String(config.coffretVariant || '49387618533719')) { notice('Choisissez vos quatre muscs sur la page du coffret avant de l’ajouter au panier.', true); return Promise.resolve(false); }
      const sum = quantity + (combined.get(id) || 0);
      if (!Number.isSafeInteger(sum)) return Promise.resolve(false);
      combined.set(id, sum);
    }
    return enqueue(async () => {
      await refresh();
      for (const [id, quantity] of combined) {
        const product = window.MDM_PRODUCT_CATALOG?.[id];
        const existing = state.items.filter(item => String(item.variant_id) === id).reduce((sum, item) => sum + item.quantity, 0);
        if (product && Number.isSafeInteger(product.stock) && quantity > Math.max(0, product.stock - existing)) throw new Error(`La quantité demandée de ${product.name} n’est plus disponible. Votre sélection n’a pas été ajoutée.`);
      }
      await request('cart/add.js', {items:[...combined].map(([id,quantity]) => ({id,quantity}))});
      await refresh(); open();
      notice('Votre sélection a été ajoutée au panier.');
      document.dispatchEvent(new CustomEvent('mdm:cart-updated', {detail:state}));
      return true;
    });
  }

  function change(key, quantity) {
    if (typeof key !== 'string' || !Number.isSafeInteger(quantity) || quantity < 0) return Promise.resolve(false);
    return enqueue(async () => { state = await request('cart/change.js', {id:key,quantity}); render(); notice(quantity ? 'Votre panier a été mis à jour.' : 'L’article a été retiré du panier.'); document.dispatchEvent(new CustomEvent('mdm:cart-updated',{detail:state})); return true; });
  }

  function addConfigured(selection) {
    const id = String(selection?.id || '');
    const quantity = Number(selection?.quantity ?? 1);
    const raw = selection?.properties;
    if (!/^\d+$/.test(id) || !Number.isSafeInteger(quantity) || quantity < 1 || !raw || typeof raw !== 'object' || Array.isArray(raw)) return Promise.resolve(false);
    const entries = Object.entries(raw);
    if (!entries.length || entries.length > 20 || entries.some(([key,value]) => !key.trim() || key.length > 100 || typeof value !== 'string' || !value.trim() || value.length > 2000)) return Promise.resolve(false);
    const properties = Object.fromEntries(entries);
    if (id === String(config.coffretVariant || '49387618533719') && !properties.Products?.trim()) { notice('Choisissez vos quatre muscs avant d’ajouter le coffret.', true); return Promise.resolve(false); }
    return enqueue(async () => {
      await refresh();
      const product = window.MDM_PRODUCT_CATALOG?.[id];
      const existing = state.items.filter(item => String(item.variant_id) === id).reduce((sum,item) => sum + item.quantity, 0);
      if (product && Number.isSafeInteger(product.stock) && quantity > product.stock - existing) throw new Error('Ce coffret n’est plus disponible dans la quantité demandée.');
      await request('cart/add.js', {items:[{id,quantity,properties}]});
      await refresh(); open(); notice('Votre coffret personnalisé a été ajouté au panier.');
      document.dispatchEvent(new CustomEvent('mdm:cart-updated',{detail:state}));
      return true;
    });
  }

  window.MDMCart = Object.freeze({add:(id,quantity=1)=>addMany([{id,quantity}]),addMany,addConfigured,open:()=>enqueue(async()=>{await refresh();open();return true;})});
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const target = event.target;
    const pure = target.closest('#add-product, [data-add-duo], [data-sticky-add]');
    if (pure && !pure.closest('[data-generic-product]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (pure.disabled || working) return;
      window.MDMCart.add(pure.matches('[data-add-duo]') ? 'duo' : $('input[name="offer"]:checked')?.value || 'solo', Math.max(1, Math.min(10, Number($('#mdm-quantity')?.value) || 1)));
      return;
    }
    if (target.closest('.cart-open')) { event.preventDefault(); event.stopImmediatePropagation(); window.MDMCart.open(); return; }
    if (target.closest('.cart-close, .continue-shopping')) { event.preventDefault(); event.stopImmediatePropagation(); close(); return; }
    const step = target.closest('[data-shopify-step], [data-shopify-remove]');
    if (step) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (working || step.disabled) return;
      const line = step.closest('[data-shopify-line]');
      const item = state?.items.find(item => item.key === line?.dataset.shopifyLine);
      if (item) change(item.key, step.hasAttribute('data-shopify-remove') ? 0 : Math.max(1, item.quantity + Number(step.dataset.shopifyStep)));
    }
  }, true);
  document.addEventListener('change', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.matches('[data-shopify-quantity]')) {
      const quantity = Math.max(1, Math.trunc(input.valueAsNumber || 1));
      change(input.closest('[data-shopify-line]').dataset.shopifyLine, quantity);
    }
    if (input.name === 'offer') {
      const product = window.MDM_PRODUCT_CATALOG?.[String(config.aliases?.[input.value])];
      const available = !!product?.stock;
      const buy = $('#add-product');
      if (buy) { buy.disabled = !available; $('span',buy).textContent = available ? 'Ajouter au panier' : 'Indisponible pour le moment'; }
      const estimate = $('[data-delivery-estimate]');
      if (estimate) estimate.dataset.available = String(available);
      document.dispatchEvent(new Event('mdm:product-ready'));
    }
  });
  window.addEventListener('pageshow', event => { if (event.persisted) refresh().catch(() => {}); });
  refresh().catch(() => { $$('.cart-open').forEach(button => { button.title = 'Ouvrir le panier'; }); });
})();
